import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  ChevronLeft,
  Settings,
  Zap,
  Layout,
  Info,
  Fuel,
  Gauge,
  ArrowRightCircle,
  Calendar,
  User,
  Shield,
  Edit2
} from "lucide-react";
import "./AddOldCarFlow.css";
import LoaderCon from "../../Common/loader/containers/loader_cont";
import Snackbar1 from "../../Common/snackbar/components/snackbar";

export default function Viewpage(props) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState(0);

  useEffect(() => {
    if (id) {
      props.viewOldCarById(props.login.token, props.login.user_id, id);
      props.viewOverviewById(props.login.token, props.login.user_id, id);
      props.viewSpecificationById(props.login.token, props.login.user_id, id);
      props.viewFeturesById(props.login.token, props.login.user_id, id);
    }
  }, [id, props.login.token, props.login.user_id]);

  const car = props.client.viewoldCarById;
  const overview = props.client.viewOverviewById;
  const specs = props.client.viewSpecificationById;
  const features = props.client.viewFetureById;

  const InfoSection = ({ title, icon, children }) => (
    <div className="old-car-flow-card" style={{ marginBottom: '24px', padding: '24px' }}>
      <div className="edit-section-title" style={{ borderBottom: '1px solid #f1f5f9', paddingBottom: '12px', marginBottom: '20px' }}>
        {icon} {title}
      </div>
      <div className="flow-grid" style={{ gap: '24px' }}>
        {children}
      </div>
    </div>
  );

  const DataPoint = ({ label, value, icon: Icon }) => (
    <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
      {Icon && <div style={{ color: '#cf2230', marginTop: '3px' }}><Icon size={18} /></div>}
      <div>
        <div style={{ fontSize: '12px', color: '#64748b', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{label}</div>
        <div style={{ fontSize: '15px', fontWeight: '600', color: '#1e293b' }}>{value || "N/A"}</div>
      </div>
    </div>
  );

  if (!car || Object.keys(car).length === 0) return <LoaderCon />;

  return (
    <div className="old-car-flow-container" style={{ backgroundColor: '#f8fafc', padding: '40px 20px' }}>
      <div style={{ maxWidth: '1100px', margin: '0 auto', width: '100%' }}>

        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '32px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <button onClick={() => navigate(-1)} className="flow-btn-secondary" style={{ padding: '10px', borderRadius: '50%', width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <ChevronLeft size={24} />
            </button>
            <div>
              <h1 style={{ fontSize: '28px', fontWeight: '800', margin: 0 }}>{car.brand} {car.carName}</h1>
              <div style={{ display: 'flex', gap: '8px', marginTop: '4px' }}>
                <span style={{ padding: '4px 8px', background: '#e2e8f0', borderRadius: '4px', fontSize: '12px', fontWeight: '600' }}>#{id.slice(-6)}</span>
                <span style={{ padding: '4px 8px', background: car.status === 'Available' ? '#dcfce7' : '#fee2e2', color: car.status === 'Available' ? '#166534' : '#991b1b', borderRadius: '4px', fontSize: '12px', fontWeight: '600' }}>{car.status}</span>
              </div>
            </div>
          </div>
          <button
            className="flow-btn-primary"
            onClick={() => navigate(`/edit/${id}`)}
            style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
          >
            <Edit2 size={18} /> Edit Vehicle
          </button>
        </div>

        {/* Hero Section: Gallery and Primary Stats */}
        <div style={{ display: 'grid', gridTemplateColumns: '1.5fr 1fr', gap: '24px', marginBottom: '24px' }}>
          <div className="old-car-flow-card" style={{ padding: '16px' }}>
            <div style={{ position: 'relative', height: '400px', borderRadius: '12px', overflow: 'hidden', backgroundColor: '#f1f5f9' }}>
              {car.image && car.image.length > 0 ? (
                <img src={car.image[selectedImage]} alt="Car" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              ) : (
                <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#94a3b8' }}>No images available</div>
              )}
            </div>
            <div style={{ display: 'flex', gap: '12px', marginTop: '16px', overflowX: 'auto', paddingBottom: '8px' }}>
              {car.image?.map((img, i) => (
                <img
                  key={i}
                  src={img}
                  alt=""
                  onClick={() => setSelectedImage(i)}
                  style={{
                    width: '80px', height: '60px', borderRadius: '6px', objectFit: 'cover', cursor: 'pointer',
                    border: selectedImage === i ? '2px solid #cf2230' : '2px solid transparent',
                    transition: 'all 0.2s'
                  }}
                />
              ))}
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
            <div className="old-car-flow-card" style={{ padding: '32px', display: 'flex', flexDirection: 'column', justifyContent: 'center', flex: 1 }}>
              <div style={{ fontSize: '14px', color: '#64748b', marginBottom: '8px' }}>Special Offer Price</div>
              <div style={{ fontSize: '36px', fontWeight: '800', color: '#cf2230' }}>₹ {car.discountedPrice?.toLocaleString() || "P.O.A"}</div>
              <div style={{ fontSize: '16px', color: '#94a3b8', textDecoration: 'line-through' }}>Market Price: ₹ {car.price?.toLocaleString()}</div>

              <div style={{ marginTop: '32px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                <DataPoint label="Kilometer" value={`${car.kilometer} km`} icon={Gauge} />
                <DataPoint label="Fuel Type" value={car.fuelType} icon={Fuel} />
                <DataPoint label="Transmission" value={overview?.transmission} icon={Settings} />
                <DataPoint label="Owners" value={overview?.owners} icon={User} />
              </div>
            </div>

            <div className="old-car-flow-card" style={{ padding: '24px', background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)', color: 'white' }}>
              <div style={{ fontSize: '14px', opacity: 0.8, marginBottom: '16px' }}>Seller's Remarks</div>
              <p style={{ margin: 0, fontSize: '15px', lineHeight: 1.6, fontStyle: 'italic', opacity: 0.9 }}>
                "{overview?.description || "No description provided for this vehicle."}"
              </p>
            </div>
          </div>
        </div>

        {/* Detailed Sections */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '24px' }}>

          <InfoSection title="History & Registration" icon={<Calendar size={20} color="#cf2230" />}>
            <DataPoint label="Reg. Year" value={overview?.registerationYear} />
            <DataPoint label="Mfg. Year" value={overview?.manufacturingYear} />
            <DataPoint label="Color" value={overview?.color} />
            <DataPoint label="Insurance" value={overview?.insurance} />
            <DataPoint label="Reg. Type" value={overview?.registerationType || "Individual"} />
          </InfoSection>

          <InfoSection title="Engine & Transmission" icon={<Settings size={20} color="#cf2230" />}>
            <DataPoint label="Engine" value={specs?.engine ? `${specs.engine} cc` : "N/A"} />
            <DataPoint label="Max Power" value={specs?.maxPower} />
            <DataPoint label="Max Torque" value={specs?.maxTorque} />
            <DataPoint label="Mileage" value={specs?.mileage} />
            <DataPoint label="Drivetrain" value={specs?.driveTrain} />
          </InfoSection>

          <InfoSection title="Dimensions & Capacity" icon={<Layout size={20} color="#cf2230" />}>
            <DataPoint label="Dimensions (LxWxH)" value={specs?.length && specs?.width && specs?.height ? `${specs.length}x${specs.width}x${specs.height}` : "N/A"} />
            <DataPoint label="Wheelbase" value={specs?.wheelbase} />
            <DataPoint label="Ground Clearance" value={specs?.groundClearance} />
            <DataPoint label="Kerb Weight" value={specs?.kerbWeight} />
            <DataPoint label="Doors" value={specs?.doors} />
            <DataPoint label="Seating Capacity" value={specs?.seatingCapacity} />
            <DataPoint label="Rows" value={specs?.rows} />
            <DataPoint label="Boot Space" value={specs?.bootspace} />
            <DataPoint label="Fuel Tank Capacity" value={specs?.fuelTankCapacity} />
          </InfoSection>

          <InfoSection title="Suspension, Steering & Brakes" icon={<Settings size={20} color="#cf2230" />}>
            <DataPoint label="Front Suspension" value={specs?.frontSuspension} />
            <DataPoint label="Rear Suspension" value={specs?.rearSuspension} />
            <DataPoint label="Front Brakes" value={specs?.frontbrakeType} />
            <DataPoint label="Rear Brakes" value={specs?.rearBrakeType} />
            <DataPoint label="Steering Type" value={specs?.steeringType} />
            <DataPoint label="Min Turning Radius" value={specs?.minTurningRadius} />
          </InfoSection>

          <InfoSection title="Wheels & Tyres" icon={<Settings size={20} color="#cf2230" />}>
            <DataPoint label="Wheels" value={specs?.wheels} />
            <DataPoint label="Front Tyres" value={specs?.frontTyres} />
            <DataPoint label="Rear Tyres" value={specs?.rearTyres} />
            <DataPoint label="Spare Wheel" value={specs?.spareWheel} />
          </InfoSection>

        </div>

        <InfoSection title="Available Features & Equipment" icon={<Zap size={20} color="#cf2230" />}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', gridColumn: 'span 2' }}>
            {features && Object.entries(features).map(([key, value]) => {
              if (typeof value === 'boolean' && value === true) {
                // Formatting key to label
                const label = key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
                return (
                  <div key={key} style={{ display: 'flex', alignItems: 'center', gap: '8px', background: '#fff', padding: '10px', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                    <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#4ade80' }}></div>
                    <span style={{ fontSize: '13px', fontWeight: '500', color: '#475569' }}>{label}</span>
                  </div>
                );
              }
              return null;
            })}
          </div>
        </InfoSection>

      </div>
      <LoaderCon />
      <Snackbar1 open={props.snackbar.response_received} close_snack_bar={() => props.close_snack_bar()} message={props.snackbar.message} />
    </div>
  );
}
